import { Component, OnInit } from "@angular/core";
import { SpecialitesService } from "../../services/specialites/specialites.service";
import { UsersService } from "src/app/services/users/users.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { AppointmentsService } from "src/app/services/appointments/appointments.service";
import { DatePipe } from "@angular/common";
import { forkJoin } from "rxjs";

@Component({
    selector: "app-programari-add",
    templateUrl: "./programari-add.component.html",
    styleUrls: ["./programari-add.component.scss"],
})
export class ProgramariAddComponent implements OnInit {
    specialties: any;
    appointment: any = {
        specialtyCode: null,
        doctorCode: null,
        ticketCode: null,
        startDate: null,
        endDate: null,
        appoinmentType: null,
        participantComment: null,
    };
    isValid = false;
    doctors: any;
    filteredDoctors: any;
    tickets: any;
    appointmentList: any;
    showList = false;
    emptyList = false;
    ticketsFound = false;
    loading: boolean = false;
    result: any;
    user: any;
    currentDay: number = 0;
    currentMonth: number = 0;
    currentYear: number = 0;
    ticketNeeded = true;
    appointments: any = [];
    message: any;
    isAvailbe: boolean = false;
    specialtyName: any;
    pipe = new DatePipe("en-US");
    test: any;
    doctorname: any;
    appointmentTypes = [
        {
            name: "Programare fara plata",
            value: "0",
            id: 0,
        },
        {
            name: "Programare cu plata",
            value: "1",
            id: 1,
        },
    ];
    isPaid: boolean = false;
    maxDate: { year: number; month: number; day: number };
    minDate: { year: number; month: number; day: number };
    isAddingFile: boolean = true;
    selectedFile: File | null = null;
    filteredSpecialties: any[] = [];
    selectedSpecialty: any;
    batch: any;
    number: any;
    constructor(
        private specialtiesService: SpecialitesService,
        private usersService: UsersService,
        private toastr: ToastrService,
        private appointmentsService: AppointmentsService,
        public router: Router,
    ) {
        const t = this;
        const currentDate = new Date();

        t.currentDay = currentDate.getDate();
        t.currentMonth = currentDate.getMonth() + 1;
        t.currentYear = currentDate.getFullYear();

        // const today = new Date();
        // this.currentYear = today.getFullYear();
        // this.currentMonth = today.getMonth() + 1; // Months are 0-based in JavaScript
        // this.currentDay = today.getDate();

        // Calculate the maximum date (30 days from now)
        const maxDate = new Date(currentDate);
        this.minDate = {
            year: maxDate.getFullYear(),
            month: maxDate.getMonth() + 1,
            day: maxDate.getDate(),
        };
        maxDate.setDate(maxDate.getDate() + 28);
        this.maxDate = {
            year: maxDate.getFullYear(),
            month: maxDate.getMonth() + 1,
            day: maxDate.getDate(),
        };
    }

    ngOnInit(): void {
        const t = this;
        t.loadItems();
    }

    loadItems() {
        const t = this;
        t.getSpecialties();
        //t.getAppointments();
    }

    updateFilteredSpecialties() {
        if (this.appointment.appoinmentType == 0) {
            // Fără plată – scoatem laboratorul
            this.filteredSpecialties = this.specialties.filter(
                (s: any) => s.code !== "LB",
            );
        } else {
            // Cu plată – toate specialitățile
            this.filteredSpecialties = this.specialties;
        }
    }
    onAppointmentTypeChange() {
        this.updateFilteredSpecialties();

        // resetăm specialitatea dacă era laborator și acum e fără plată
        if (
            this.appointment.appoinmentType === 0 &&
            this.appointment.specialtyCode === "LB"
        ) {
            this.appointment.specialtyCode = null;
        }
    }

    sortAlphabethic(item: any) {
        const t = this;

        var ar = item.sort(function (a: any, b: any) {
            var nA = a.name.toLowerCase();
            var nB = b.name.toLowerCase();

            if (nA < nB) return -1;
            else if (nA > nB) return 1;
            return 0;
        });
        return item;
    }

    getSpecialties() {
        const t = this;
        this.specialtiesService
            .getMedicalSpecialization()
            .subscribe((data: any) => {
                t.getUser();
                t.specialties = t.sortAlphabethic(data);
                this.usersService.getPatient().subscribe((data: any) => {
                    t.user = data;
                    for (let i = 0; i < t.specialties.length; i++) {
                        t.specialties[i].ticketNeeded = true;
                    }
                    if (t.user.annex13) {
                        for (
                            let index = 0;
                            index < t.user.annex13SpecialtyEntities?.length;
                            index++
                        ) {
                            const element =
                                t.user.annex13SpecialtyEntities[index];

                            for (let i = 0; i < t.specialties.length; i++) {
                                const element2 = t.specialties[i];
                                if (element.code == element2.code) {
                                    t.specialties[i].ticketNeeded = false;
                                }
                            }
                        }
                    }
                });

                t.specialties = t.sortAlphabethic(data);
                this.updateFilteredSpecialties();
                // t.test = data;
                // var ar = t.test.sort(function(a, b) {
                // 	var nA = a.name.toLowerCase();
                // 	var nB = b.name.toLowerCase();

                // 	if (nA < nB) return -1;
                // 	else if (nA > nB) return 1;
                // 	return 0;
                // });
                // t.specialties = t.test;
            });
    }

    getAppointments() {
        const t = this;
        this.appointmentsService
            .get({ startDate: "2021/01/01" })
            .subscribe((data: any) => {
                data.forEach((b: any) => {
                    if (t.getStatus(b) === "Onorata") {
                        t.appointments.push(b);
                    }
                });
            });
    }

    getUser() {
        const t = this;
        this.usersService.getPatient().subscribe((data: any) => {
            t.user = data;

            if (t.user.annex13) {
                t.ticketNeeded = true;
            }
        });
    }

    getStatus(appointment: {
        status: string;
        startDate: string | number | Date;
    }) {
        const status = appointment.status.toLowerCase();
        const now = new Date();
        const appointmentDate = new Date(appointment.startDate);

        if (appointmentDate > now) {
            return "Activa";
        }

        if (status === "active") {
            return "Neonorata";
        }
        if (status === "efectuat") {
            return "Onorata";
        }
    }

    showMessage(event: any) {
        const t = this;

        // poate reusti sa il scrii mai frumos
        let tempTicket = event;
        t.isAvailbe = true;
        let date = new Date();

        if (tempTicket.used == 0) {
            let newDate = new Date(tempTicket.date || tempTicket.createdDate);
            let tempDate =
                event.validity -
                Math.floor(
                    (Date.UTC(
                        date.getFullYear(),
                        date.getMonth(),
                        date.getDate(),
                    ) -
                        Date.UTC(
                            newDate.getFullYear(),
                            newDate.getMonth(),
                            newDate.getDate(),
                        )) /
                        (1000 * 60 * 60 * 24),
                );
            if (
                tempTicket.diagnosticType == "Cronic" ||
                tempTicket.diagnosticType == "C" ||
                tempTicket.diagnosticType == "Acut" ||
                tempTicket.diagnosticType == "A" ||
                tempTicket.diagnosticType == "Subacut" ||
                tempTicket.diagnosticType == "S" ||
                tempTicket.diagnosticType == "Acut/Subacut" ||
                tempTicket.diagnosticType == "A/S" ||
                tempTicket.diagnosticType == "ACUT" ||
                tempTicket.diagnosticType == "CRONIC" ||
                tempTicket.diagnosticType == "SUBACUT"
            ) {
                t.message =
                    " Mai aveti la dispozitie   " +
                    tempDate +
                    " zile pentru prima folosire a biletului de trimitere.";
            }

            if (
                tempTicket.diagnosticType == "Progr. nat./Preventie" ||
                tempTicket.diagnosticType == "P" ||
                tempTicket.diagnosticType == "M" ||
                tempTicket.diagnosticType == "Management de caz"
            ) {
                t.message =
                    " Mai aveti la dispozitie   " +
                    tempDate +
                    " zile pentru folosirea biletului de trimitere.";
            }
        } else if (tempTicket.used == 1 || tempTicket.used == 2) {
            let newDate = new Date(tempTicket.firstUsedDate);
            let tempDate =
                90 -
                Math.floor(
                    (Date.UTC(
                        date.getFullYear(),
                        date.getMonth(),
                        date.getDate(),
                    ) -
                        Date.UTC(
                            newDate.getFullYear(),
                            newDate.getMonth(),
                            newDate.getDate(),
                        )) /
                        (1000 * 60 * 60 * 24),
                );
            if (
                tempTicket.diagnosticType == "Cronic" ||
                tempTicket.diagnosticType == "C" ||
                tempTicket.diagnosticType == "Acut" ||
                tempTicket.diagnosticType == "A" ||
                tempTicket.diagnosticType == "Subacut" ||
                tempTicket.diagnosticType == "S" ||
                tempTicket.diagnosticType == "Acut/Subacut" ||
                tempTicket.diagnosticType == "A/S" ||
                tempTicket.diagnosticType == "ACUT" ||
                tempTicket.diagnosticType == "CRONIC" ||
                tempTicket.diagnosticType == "SUBACUT"
            ) {
                t.message =
                    " Mai aveti la dispozitie un numar de " +
                    (3 - tempTicket.used) +
                    " programari pe acest bilet de trimitere.";
            }
        } else {
            t.isAvailbe = false;
        }

        // nu mai stiu ce am facut aici
        // if (t.tickets) {
        // 	let currentDate = new Date();
        // 	let i = 0;
        // 	let lastDate = new Date();
        // 	t.appointments.forEach((b: any) => {
        // 		const appointmentDate = new Date(b.startDate);
        // 		if (b.specialtyName == t.specialtyName) {
        // 			if (
        // 				Math.floor(
        // 					(Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) -
        // 						Date.UTC(
        // 							appointmentDate.getFullYear(),
        // 							appointmentDate.getMonth(),
        // 							appointmentDate.getDate()
        // 						)) /
        // 						(1000 * 60 * 60 * 24)
        // 				) < 90
        // 			) {
        // 				i++;
        // 				lastDate = new Date(b.startDate);
        // 			}
        // 		}
        // 	});
        // 	let j =
        // 		90 -
        // 		Math.floor(
        // 			(Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) -
        // 				Date.UTC(lastDate.getFullYear(), lastDate.getMonth(), lastDate.getDate())) /
        // 				(1000 * 60 * 60 * 24)
        // 		);
        // 	if (i > 3) {
        // 		t.message = 'Acest bilet de trimitere a expirat.';
        // 	} else {
        // 		i = 3 - i;
        // 		t.message =
        // 			'Acest bilet de trimitere se mai poate folosi ' +
        // 			(i == 1 ? 'o singura data' : 'de ' + i + ' ori') +
        // 			' in urmatoarele ' +
        // 			j +
        // 			' zile.';
        // 	}
        // 	t.isAvailbe = true;
        // } else {
        // 	t.isAvailbe = false;
        // }
    }

    getTickets(event: any) {
        forkJoin({
            externalTickets: this.usersService.getExternalTickets(),
            internalTickets: this.usersService.getMyTickets(),
        }).subscribe({
            next: ({ externalTickets, internalTickets }) => {
                const external = (externalTickets || []).map((ticket: any) => ({
                    ...ticket,
                    isExternal: true,
                }));

                const internal = (internalTickets || []).map((ticket: any) => ({
                    ...ticket,
                    isExternal: false,
                }));

                this.tickets = [...external, ...internal].filter(
                    (ticket: any) =>
                        (ticket.senderSpecialization ||
                            ticket.specialtyName) === event.name,
                );

                this.tickets = this.tickets.filter(
                    (s: any) => s.status !== "EXPIRED",
                );

                this.tickets = this.tickets.map((item: any) => ({
                    ...item,
                    displayLabel: `${item.batch} | ${item.number} | ${item.isExternal ? "Extern" : "Intern"}`,
                }));

                this.ticketsFound = this.tickets.length > 0;
            },
            error: () => {
                this.tickets = [];
                this.ticketsFound = false;
            },
        });
    }

    loadDoctors(ev: any) {
        const t = this;
        t.isValid = true;
        t.appointment.ticketCode = null;
        t.appointment.doctorCode = null;
        t.isAvailbe = false;

        this.selectedSpecialty = ev; // memorize full object for later

        t.specialtyName = ev.name;
        t.doctors = t.getDoctors(ev.doctors);

        const activeDoctors = [];
        for (let index = 0; index < t.doctors.length; index++) {
            if (t.doctors[index].active) {
                activeDoctors.push(t.doctors[index]);
            }
        }
        t.doctors = activeDoctors;

        // ticketNeeded will now depend mainly on isPaid (see next section)
    }

    onDoctorChange(): void {
        if (
            this.appointment.specialtyCode &&
            this.appointment.doctorCode &&
            this.selectedSpecialty
        ) {
            this.getTickets(this.selectedSpecialty);
            this.batch = null;
            this.number = null;
            this.appointment.ticketCode = null;
        }
    }

    LoadAppointmentType(ev: any) {
        if (ev.id == 1) {
            // cu plata
            this.isPaid = true;
            this.ticketNeeded = false; // optional
        }

        if (ev.id == 0) {
            // fara plata
            this.isPaid = false;
            this.ticketNeeded = true; // obligatoriu
        }

        this.appointment = {
            specialtyCode: null,
            doctorCode: null,
            ticketCode: null,
            startDate: null,
            endDate: null,
            appoinmentType: null,
            participantComment: null,
        };
    }

    loadList() {
        const t = this;
        t.formatDate();
        t.showList = true;

        t.appointmentList = [];
        t.loading = false;
        t.doctors.forEach((doctor: any) => {
            if (doctor.code == t.appointment.doctorCode) {
                t.doctorname = doctor.name;
            }
        });
        t.loading = true;
        t.usersService
            .getMyAppointmentsSlots(this.appointment)
            .subscribe((data: any) => {
                t.appointmentList = [];
                t.appointmentList = data;
                if (t.appointmentList) {
                    t.loading = true;
                    if (t.appointmentList.length != 0) {
                        t.emptyList = false;
                    } else {
                        t.emptyList = true;
                    }
                } else {
                    t.loading = false;
                }
                t.loading = false;
            });
    }

    formatDate() {
        const t = this;
        const sDate =
            this.appointment.startDate.year +
            "/" +
            this.appointment.startDate.month +
            "/" +
            this.appointment.startDate.day;
        this.appointment.startDate = sDate;
        const eDate =
            this.appointment['endDate']['year'] +
            "/" +
            this.appointment.endDate.month +
            "/" +
            this.appointment.endDate.day;
        this.appointment.endDate = eDate;
    }
    onTicketChange(ticket: any) {
        if (ticket) {
            this.appointment.ticketCode = ticket;
            this.batch = ticket.batch;
            this.number = ticket.number;
            this.isAddingFile = false;
            this.showMessage(ticket);
        } else {
            this.isAddingFile = true;
            this.appointment.ticketCode = null;
            this.batch = null;
            this.number = null;
        }
    }

    showTicketField(): boolean {
  // Fara plata: bilet doar pentru specialitati ambulator, nu laborator
  if (this.appointment.appoinmentType === 0) {
    return this.appointment.specialtyCode !== 'LB';
  }

  // Cu plata: bilet DOAR pentru laborator
  if (this.appointment.appoinmentType === 1) {
    return this.appointment.specialtyCode === 'LB';
  }

  return false;
}
    selectAppointment(app: any): void {
        const t = this;

        const tempDate = new Date(app.startDateTime);
        const hoursMin =
            (tempDate.getHours() < 10
                ? "0" + tempDate.getHours()
                : tempDate.getHours()) +
            ":" +
            (tempDate.getMinutes() < 10
                ? "0" + tempDate.getMinutes()
                : tempDate.getMinutes()) +
            ":00";

        let appointmentModel: any;

        if (this.appointment.ticketCode) {
            appointmentModel = {
                eventUid: app.id.toString(),
                scheduleId: app.scheduleID.toString(),
                specialtyCode: this.appointment.specialtyCode,
                batch: this.batch || "",
                number: this.number || "",
                isPaid: this.appointment.appoinmentType == 0 ? false : true, // păstrează logica existentă
                participantComment: this.appointment.participantComment,
                startHour: hoursMin,
                doctorCode: this.appointment.doctorCode,
                startDate: app.startDate,
                // fileId: this.appointment.fileId || null, // dacă îl ai în model
            };
        } else {
            appointmentModel = {
                eventUid: app.id.toString(),
                scheduleId: app.scheduleID.toString(),
                specialtyCode: this.appointment.specialtyCode,
                isPaid: this.appointment.appoinmentType == 0 ? false : true,
                participantComment: this.appointment.participantComment,
                startHour: hoursMin,
                doctorCode: this.appointment.doctorCode,
                startDate: app.startDate,
                // fileId: this.appointment.fileId || null,
            };
        }

        // Folosește service-ul care știe de multipart
        this.appointmentsService
            .makeAppointment(appointmentModel, this.selectedFile)
            .subscribe(
                (data: any) => {
                    if (data.success) {
                        t.toastr.success(
                            "Programarea ta a fost efectuata cu succes si te asteptam la ora stabilita. Din cauza numarului mare de pacienti exista posibilitatea ca intre programari sa mai apara decalaje intre programari.  Iti multumim pentru intelegere!",
                            "Programare",
                        );

                        setTimeout(() => {
                            t.router.navigate(["/", "programari"]).then(() => {
                                window.location.reload();
                            });
                        }, 2000);
                    } else {
                        t.toastr.error(data.message, "Programare");
                    }
                },
                () => {
                    t.toastr.error("Programare esuata");
                },
            );
    }

    getDoctors(doctors: any) {
        const t = this;
        if (t.appointment.specialtyCode === "MF") {
            return [t.user.familyDoctorEntity];
        } else {
            return doctors;
        }
    }

    onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            this.selectedFile = input.files[0];
        } else {
            this.selectedFile = null;
        }
    }
}
